import { ILoginPageContent } from '../../models';

export const loginContent: ILoginPageContent = {
  logo: '',
  title: '',
  description: '',
  remember_login: '',
  forgot_password: '',
  forgot_password_link: '',
  newMember: '',
  registerLink: '',
  bannerImageUrl: '',
  trialLabel: '',

  errorEmail: '',
  errorNotBlank: '',
  errorLoginFailed: '',

  labelEmail: '',
  labelPassword: '',
  labelButton_login: '',
  labelRegister: '',
  labelBackToHome: '',

  defaultEmail: '',
  defaultPassword: '',

  placeholderEmail: '',
  placeholderPassword: '',
};
